import * as React from 'react';

import OrgLocationList from './OrgLocationList';
import LocationEditPopup from '~/apps/shared/containers/locations/LocationEditPopup';
import {navigate} from '~/router';


export default (params) => {
  return OrgLocationList(params,
    <LocationEditPopup
      orgId={params.orgId}
      locationId={params.locationId}
      onReturn={() => navigate('admin.orgs.locations', {orgId: params.orgId})}
    />
  );
};
